module.exports = __webpack_public_path__ + "static/media/product-7.f10485f6.png";